import { Impact } from '..';
import { CarbonOffset } from '../carbon-offsets';
import { CarbonRemoval } from '../carbon-removal';
import { HabitatRestoration } from '../habitat-restoration';
import { ImpactType } from '../impact';
import { Tree } from '../tree';

export const isNumber = (v: any): v is number => typeof v == 'number';
export const isString = (v: any): v is string => typeof v == 'string';
export const isInt = (v: any): v is number => typeof v == 'number' && Number.isInteger(v);
export const isDate = (v: any): v is Date => v instanceof Date && !isNaN(v as any);
export const isBoolean = (v: any): v is boolean => typeof v == 'boolean';
export const isObject = (v: any): v is Record<string, any> => v !== null && typeof v === 'object';
export const isPromise = (v: any): v is Promise<any> => v instanceof Promise;

export const isBetween = (value: number, min: number, max: number): boolean => min <= value && value <= max;
export const isEmptyObject = (object: any) => {
  if (object.constructor !== Object) return false;
  for (const _ in object) return false;
  return true;
};

export const isTree = (i: Impact): i is Tree => i.impactType === ImpactType.TREES;

export const isCarbonOffset = (i: Impact): i is CarbonOffset => i.impactType === ImpactType.CARBON_OFFSETS;

export const isCarbonRemoval = (i: Impact): i is CarbonRemoval => i.impactType === ImpactType.CARBON_REMOVAL;

export const isHabitatRestoration = (i: Impact): i is HabitatRestoration =>
  i.impactType === ImpactType.HABITAT_RESTORATION;
